import { render } from "./LayoutClean.vue?vue&type=template&id=0f62f467&scoped=true"
import script from "./LayoutClean.vue?vue&type=script&lang=js"
export * from "./LayoutClean.vue?vue&type=script&lang=js"

import "./LayoutClean.vue?vue&type=style&index=0&id=0f62f467&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f62f467"]])

export default __exports__